import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let AlbumDesc = class AlbumDesc extends Vue {
};
tslib_1.__decorate([
    Prop()
], AlbumDesc.prototype, "description", void 0);
tslib_1.__decorate([
    Prop({ default: [] })
], AlbumDesc.prototype, "tags", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], AlbumDesc.prototype, "showTags", void 0);
AlbumDesc = tslib_1.__decorate([
    Component
], AlbumDesc);
export default AlbumDesc;
